import { Link } from 'react-router-dom';

import { adminSidebar } from 'lib/constants/sidebar/adminSidebar';

import SidebarList from 'components/Sidebars/Sidebar/components/SidebarList';
import Icon from 'components/shared/Icon/Icon';
import Logout from 'components/shared/Logout/Logout';

const Sidebar = ({ match }) => {
  if (
    match &&
    match.url &&
    (match.url === '/admin/login' || match.url.includes('/admin/password'))
  ) {
    return null;
  }

  return (
    <aside className="z-40 flex grow flex-col justify-between shadow-[4px_0px_16px_rgba(0,79,107,0.06)]">
      <div className="flex flex-col">
        <Link
          to="/admin"
          className="flex h-[40px] w-full cursor-pointer items-center justify-center">
          <Icon icon="logo-symbol" size={26} className="cursor-pointer" />
        </Link>
        <div className="flex grow flex-col justify-between shadow-[4px_0px_16px_rgba(0,79,107,0.06)]">
          <SidebarList list={adminSidebar} />
        </div>
      </div>
      <div className="flex flex-col items-center gap-3 pb-[86px]">
        <Logout adminPortal showText={false} />
      </div>
    </aside>
  );
};

export default Sidebar;
